<template>
    <div class="flashcard-game-container">
      <h1>{{ $t(titleKey) }}</h1>
      <div class="cards-container">
        <div
          v-for="card in cards"
          :key="card.id"
          class="card"
          @click="flipCard(card)"
        >
          <div :class="{ 'card-inner': true, 'is-flipped': card.isFlipped }">
            <div class="card-front">
              <p class="card-content">{{ $t(card.term) }}</p>
            </div>
            <div class="card-back">
              <!-- Show definition for regular cards, image for the kitten card -->
              <p v-if="!card.image" class="card-content">{{ $t(card.definition) }}</p>
              <img v-if="card.image" :src="card.image" alt="Kitten" class="card-image">
            </div>
          </div>
        </div>
      </div><br>
      
      <div class="buttons-container">
        <button @click="navigateToTool" class="navigate-button">Framework</button>
        <button @click="startAnotherGame" class="start-game-button">Back</button>
      <button @click="nextGame" class="reset-game-button">Next</button>
   
   
    </div>
    </div><br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  
  export default {
    setup() {
      const cards = ref([
      { id: 1, term: '10basics-match-term1', definition: '10basics-match-def-1', isFlipped: false },
      { id: 1, term: '10basics-match-term2', definition: '10basics-match-def-2', isFlipped: false },
      // Example with an external image link
      { id: 3, term: '10basics-match-term3', definition: '10basics-match-def-3', isFlipped: false },
      { id: 4, term: '10basics-match-term4', definition: '10basics-match-def-4', isFlipped: false }, 
      { id: 5, term: '10basics-match-term5', definition: '10basics-match-def-5', isFlipped: false },
      { id: 5, term: '10basics-match-term6', definition: '10basics-match-def-6', isFlipped: false },
      // Another example with an external image link
      { id: 7, term: '10basics-match-term7', definition: '10basics-match-def-7', isFlipped: false }, 
      { id: 8, term: '10basics-match-term8', definition: '10basics-match-def-8', isFlipped: false }, 
    ]);
    const router = useRouter();
    const titleKey = '10basicsgameTitle';

      const flipCard = (card) => {
        card.isFlipped = !card.isFlipped;
      };
      const navigateToTool = () => {
      router.push({ path: '/basics' }); 
    };

    const startAnotherGame = () => {
      router.push({ path: '/games/basics9' }); 
    };
    const nextGame = () => {
      router.push({ path: '/games/menu' }); 
    };
      
  
      return {
        cards,
      flipCard,
      nextGame,
      titleKey,
      navigateToTool,
      startAnotherGame,
      };
    },
  };
  </script>
  
  <style scoped>
  .flashcard-game-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;
    margin: auto;
    padding: 20px;
  }
  
  .cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin-top: 20px;
  }
  
  .card {
    width: 300px;
    height: 180px;
    perspective: 1000px;
  }
  
  .card-inner {
    width: 100%;
    height: 100%;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    cursor: pointer;
  }
  
  .card-front, .card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    color: #fff;
    font-size: 18px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);

  }
  
  .card-front {
    background-color: #4A148C;
  }
  
  .card-back {
    background-color: #36454f;
    transform: rotateY(180deg);
  }
  
  .card-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .card-content {
    font-size: 16px;
    text-align: center;
  }
  
  .card-inner.is-flipped {
    transform: rotateY(180deg);
  }
  
  .reset-game-button, .navigate-button, .start-game-button {
    margin-top: 30px;
    padding: 10px 20px;
    background-color: #4A148C;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .reset-game-button:hover {
    background-color: #362f78;
  }

  .card-image {
    width: 80%;
    height: 80%;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    cursor: pointer;
}
  </style>
  